export default __webpack_public_path__ + "static/media/id-billing-picturemark-d.fe511301.svg";